import request from '@/utils/request'

// 设备数据中心
export const deviceDataList = (params)=>{
  return request({
    url: '/admin-api/client/pc/device/deviceNames/get',
    method: 'get',
    params:params
  })
}
